import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import ChatSection from 'src/components/ChatSection'
import { GlobalModalTypes } from 'src/components/GlobalModals/GlobalModalContainer'
import { Loader } from 'src/components/shared/Loader'
import { desktopAssets } from 'src/containers/PreCache'
import { showGlobalModal } from 'src/ducks/layout'
import Amplitude from 'src/utils/amplitudeHelper'
import { useAuditoriumController } from 'src/utils/useAuditoriumController'
import { useTrack } from 'src/utils/useTrack'
import styled from 'styled-components'
import config from '../config'
import { useAutoMute } from '../utils/useAutoMute'
import { HiMiniArrowLeft } from 'react-icons/hi2'

export default function AuditoriumPage({ currentUser }) {
  useAutoMute()
  const hasAuditoriumAccess = useAuditoriumController(currentUser)
  const dispatch = useDispatch()
  useTrack({})

  useEffect(() => {
    document.title = `${config.eventName} | Auditorium`
    Amplitude.visit('Auditorium')
  }, [])

  const handleGoBack = () => {
    window.history.back()
  }

  if (!hasAuditoriumAccess) {
    return <Loader />
  }

  return (
    <AuditoriumWrapper>
      <Container>
        <div className="d-flex content">
          <div id="video">
            <div className="banner d-flex flex-column">
              <img src={desktopAssets.hallBanner} />
              <div role="button" className="d-flex align-items-center text-white back-btn" onClick={handleGoBack}>
                <HiMiniArrowLeft />
                <span>Back</span>
              </div>
            </div>
            {!config.HALL_VIDEO_URL ? (
              <>
                <div
                  className="iframe-dummy"
                  style={{
                    width: '100%',
                    backgroundColor: '#000',
                    marginBlock: '24px',
                  }}
                ></div>
              </>
            ) : (
              <>
                <iframe
                  title="auditorium-stream"
                  id="1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6-live-507a30e6-8cf4-adb9-bbb4-5711d8ba79da"
                  src={config.HALL_VIDEO_URL}
                  frameBorder="0"
                  scrolling="no"
                  allow="autoplay;encrypted-media;fullscreen"
                ></iframe>
              </>
            )}

            <div className="controls">
              <Button className="theme-btn" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Agenda))}>
                Programme & Agenda
              </Button>
            </div>
          </div>
          <div id="panel">
            <ChatSection currentUser={currentUser} />
            {/* <iframe src={config.SLIDO_URL} height="100%" width="100%" frameBorder="0" style={{ minHeight: '600px' }} title="Slido"></iframe> */}
          </div>
        </div>
      </Container>
    </AuditoriumWrapper>
  )
}

const AuditoriumWrapper = styled.div`
  background-image: url(${desktopAssets.auditoriumBg});
  background-size: cover;
  background-position: center;
  min-height: calc(100dvh - 37px);
`

const Container = styled.div`
  position: relative;
  max-width: 1140px;
  margin: 0 auto;
  min-height: calc(100dvh - 30px);
  overflow: hidden;

  .content {
    gap: 20px;
  }

  .back-btn {
    gap: 8px;
  }

  #video {
    flex-basis: 70%;
    min-width: 0;

    .banner {
      gap: 8px;
      margin-bottom: 24px;
    }

    .back-btn {
      flex-shrink: 0;
    }

    .banner > img {
      flex: 1;
      min-width: 0;
      width: 100%;
      max-width: 100%;
      display: block;
    }

    iframe,
    .iframe-dummy {
      aspect-ratio: 16/9;
      width: 100%;
      border: 2px solid #ccc;
    }

    .controls {
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  #panel {
    flex-basis: 30%;

    iframe {
      aspect-ratio: 1/1;
      width: 100%;
    }
  }

  @media (min-width: 1400px) {
    max-width: 1380px;
    display: flex;

    #video {
      padding-top: 3%;
      padding: 2%;
    }
  }
`
